import React from 'react';
import Header from '@components/Comman/Header';
import { Tabs } from 'antd';
import type { TabsProps } from 'antd';
// import { Basicinfo } from './Basicinfo';
import { Basicinfo } from '../../components/Setup/Basicinfo';
// import { BusinessSetup } from '../../components/Setup/Setup';
import BusinessSetup from '../../components/Setup/Setup'
import { useNavigate } from 'react-router-dom';

// const items: TabsProps['items'] = [
//     {
//         key: '1',
//         label: 'Basic Information',
//         children: <Basicinfo />,
//     },
//     {
//         key: '2',
//         label: 'Address & Contact Details',
//         children: <Adressdetails />,
//     },
// ];

const onChange = (key: string) => {
    console.log(key);
};

const Setup = () => {
    const navigate = useNavigate()
    return (
        <div>
            <Header pagTitle="Let’s setup your ReferUs business details" />
            <div className="contentBody">
                <div className="bodycard">
                    <div className="bodycardheading">
                        {' '}
                        <div className="mobileView buttonsvgs" onClick={()=> navigate(-1)}>
                            {' '}
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="24"
                                height="25"
                                viewBox="0 0 24 25"
                                fill="none"
                            >
                                <rect
                                    x="0.4"
                                    y="1.18168"
                                    width="23.2"
                                    height="23.2"
                                    rx="11.6"
                                    stroke="#F47523"
                                    stroke-width="0.8"
                                />
                                <path
                                    d="M14 8.78168L10 12.7817L14 16.7817"
                                    stroke="#F47523"
                                    stroke-width="1.25"
                                    stroke-linecap="round"
                                />
                            </svg>
                        </div>
                        Setup
                    </div>
                    
                    <div className="cardContentbody">
                        <BusinessSetup />

                        {/* <Tabs
                            className="customeTabs"
                            defaultActiveKey="1"
                            items={items}
                            onChange={onChange}
                        /> */}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Setup;
